import {
  Box,
  Button,
  Container,
  MenuItem,
  AppBar as MuiAppBar,
  Toolbar,
  Typography,
  IconButton,
  Menu,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../long-logo.svg";

const TRIAL_BOOKING_URL = "https://book.stripe.com/28o3fFfSQ5Vu03S8ww";

export const AppBar = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isMenuOpen = Boolean(anchorEl);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const menuItems = [
    { label: "Home", scrollTo: "home", path: "/" },
    { label: "About us", scrollTo: "aboutus", path: "/" },
    // { label: "Events", scrollTo: "events", path: "/" },
    { label: "Classes", scrollTo: "classSchedule", path: "/" },
    { label: "Benefits", scrollTo: "benefits", path: "/" },
    { label: "Pricing", scrollTo: "pricing", path: "/" },
    { label: "Journey", scrollTo: "article", path: "/journey" },
    {
      label: "Bachelorette party",
      scrollTo: "bachelorette-party",
      path: "/bachelorette-party",
    },
    { label: "FAQ", path: "/faq" },
  ];

  return (
    <MuiAppBar
      position="fixed"
      elevation={0}
      sx={{
        width: "100%",
        bgcolor: "background.paper",
        borderBottom: "1px solid",
        borderColor: "divider",
        backdropFilter: "blur(24px)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
    >
      <Container maxWidth="lg">
        <Toolbar
          variant="regular"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 2,
          }}
        >
          {/* Logo */}
          <Box sx={{ display: "flex", alignItems: "center", flexShrink: 0 }}>
            <img
              src={logo}
              style={{ width: "140px", height: "25px", cursor: "pointer" }}
              alt="Hoppenhagen logo"
              onClick={() => {
                navigate("/");
                setTimeout(() => {
                  document.getElementById("home")?.scrollIntoView({ behavior: "smooth" });
                }, 100);
              }}
            />
          </Box>

          {/* Desktop nav links */}
          <Box sx={{ display: { xs: "none", md: "flex" }, alignItems: "center" }}>
            {menuItems.map((item, index) => (
              <MenuItem
                key={index}
                onClick={() => {
                  if (item.scrollTo) {
                    navigate(item.path, { state: { scrollTo: item.scrollTo } });
                  } else {
                    navigate(item.path);
                  }
                }}
                sx={{ px: 1.5, py: 0.5 }}
              >
                <Typography variant="body2" sx={{ fontWeight: 600, color: "text.primary" }}>
                  {item.label}
                </Typography>
              </MenuItem>
            ))}
          </Box>

          {/* Desktop CTA button */}
          <Box sx={{ display: { xs: "none", md: "flex" }, flexShrink: 0 }}>
            <Button
              href={TRIAL_BOOKING_URL}
              variant="contained"
              size="small"
              sx={{
                bgcolor: "primary.main",
                color: "common.white",
                fontWeight: 800,
                borderRadius: 2,
                px: 2.5,
                py: 1,
                fontSize: 13,
                whiteSpace: "nowrap",
                "&:hover": { bgcolor: "primary.dark" },
              }}
            >
              Book Trial - 80 DKK
            </Button>
          </Box>

          {/* Mobile Menu */}
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="Open navigation menu"
              onClick={handleMenuOpen}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={isMenuOpen}
              onClose={handleMenuClose}
              PaperProps={{ style: { width: "220px" } }}
            >
              {menuItems.map((item, index) => (
                <MenuItem
                  key={index}
                  onClick={() => {
                    handleMenuClose();
                    if (item.scrollTo) {
                      navigate(item.path, { state: { scrollTo: item.scrollTo } });
                    } else {
                      navigate(item.path);
                    }
                  }}
                >
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>{item.label}</Typography>
                </MenuItem>
              ))}
              <Box sx={{ px: 2, py: 1.5 }}>
                <Button
                  href={TRIAL_BOOKING_URL}
                  variant="contained"
                  fullWidth
                  sx={{
                    bgcolor: "primary.main",
                    color: "common.white",
                    fontWeight: 800,
                    borderRadius: 2,
                    fontSize: 13,
                    "&:hover": { bgcolor: "primary.dark" },
                  }}
                >
                  Book Trial - 80 DKK
                </Button>
              </Box>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </MuiAppBar>
  );
}
